import { Base } from '../../abstract/base.model';
import { isRecord } from '../utils/is-record';
import { nullableString } from '../utils/wire-value-utils';

/**
 * A support ticket that has not been assigned to an organization, built from the hub's
 * `/admin/support-tickets/unassigned` JSON (hub `UnassignedTicketResponse`). Read-only in admin: a ticket
 * changes only through the assign action. Fields the hub didn't send stay `undefined`.
 */
export class UnassignedTicket extends Base {
  ticketNumber?: string | null;
  subject?: string | null;
  status?: string | null;
  priority?: string | null;

  // Joined from the creator's profile
  contactEmail?: string | null;
  contactPhone?: string | null;
  contactName?: string | null;

  constructor(data: unknown) {
    super(data);
    const source = isRecord(data) ? data : {};
    this.ticketNumber = nullableString(source['ticketNumber']);
    this.subject = nullableString(source['subject']);
    this.status = nullableString(source['status']);
    this.priority = nullableString(source['priority']);
    this.contactEmail = nullableString(source['contactEmail']);
    this.contactPhone = nullableString(source['contactPhone']);
    this.contactName = nullableString(source['contactName']);
  }
}
